define('ordersDetailOrderProductStockItemView',[
  'module',
  'app',
  'marionette',
  'underscore',
  'settings',
  'dateUtils',
  'template!ordersDetailOrderProductStockItemView'
], function (
  Module,
  App,
  Marionette,
  _,  
  Settings,
  DateUtil,
  Tpl
) {
  'use strict';   

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'orders-detail-order-product-stock-item-view',

    ui: {      
      stockInfos: '.stock-infos',
      stockInfosText: '.stock-infos .text',    
      stockAmountWarning: '.stock-amount-warning',
      stockAmountWarningText: '.stock-amount-warning .text'
    }, 

    onRender: function() {     
      var newArrivalQuantity = '';
      var newArrivalDate = '';
      var text = '';
      var options = this.model.get('productOptions')?this.model.get('productOptions').replaceAll('null', '').trim():'';

      if(this.model.get('stockQuantity') >= this.model.get('orderQuantity')) {
        text = _.i18n('stock.infos')
        .replace('%amount', this.model.get('stockQuantity') ? this.model.get('stockQuantity') : 0)
        .replace('%variation', options);

        this.ui.stockInfosText.html(text);      
        this.ui.stockAmountWarning.hide();
        this.ui.stockInfos.css('display', 'flex');
      } else {
        newArrivalQuantity = this.model.get('newArrivalQuantity') ? this.model.get('newArrivalQuantity') : 0;         
        if (newArrivalQuantity > 0)
          newArrivalDate = DateUtil.toDateFormatString(this.model.get('newArrivalETA'));

        text = _.i18n('stock.amount.warning').replace('%amount', this.model.get('stockQuantity') ? this.model.get('stockQuantity') : 0)
        .replace('%variation', options)
        .replace('%nextArrivalAmount', newArrivalQuantity)
        .replace('%nextArrivaldate', newArrivalDate);

        this.ui.stockAmountWarningText.html(text);    
        this.ui.stockAmountWarning.css('display', 'flex');
        this.ui.stockInfos.hide();
      }
    }    
  });
});

